import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import {
  Layout,
  Menu,
  Typography,
  Button,
  theme,
  Card,
  Drawer,
  Dropdown,
  Space,
  Avatar,
  Modal
} from 'antd';
import {
  DashboardOutlined,
  FileTextOutlined,
  QuestionCircleOutlined,
  BookOutlined,
  TeamOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UserOutlined,
  LogoutOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons';
import { useAuth } from '../contexts/AuthContext';

const { Header, Sider, Content } = Layout;
const { Title } = Typography;

const AdminLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  // Detecta se é mobile
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const menuItems = [
    {
      key: '/dashboard',
      icon: <DashboardOutlined />,
      label: 'Dashboard',
    },
    {
      key: '/noticias',
      icon: <FileTextOutlined />,
      label: 'Notícias',
    },
    {
      key: '/perguntas',
      icon: <QuestionCircleOutlined />,
      label: 'Perguntas Frequentes',
    },
    {
      key: '/publicacoes',
      icon: <BookOutlined />,
      label: 'Publicações',
    },    {
      key: '/parceiros',
      icon: <TeamOutlined />,
      label: 'Parceiros',
    },
  ];

  const handleLogout = () => {
    Modal.confirm({
      title: 'Confirmar Logout',
      icon: <ExclamationCircleOutlined />,
      content: 'Tem certeza que deseja sair do sistema?',
      okText: 'Sim, sair',
      cancelText: 'Cancelar',
      onOk: async () => {
        await logout();
        navigate('/login');
      },
    });
  };

  const userMenuItems = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: `${user?.username || 'Usuário'}`,
      disabled: true,
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Sair',
      onClick: handleLogout,
    },  ];

  const handleMenuClick = ({ key }) => {
    navigate(key);
    if (isMobile) {
      setDrawerVisible(false);
    }
  };

  const toggleMobileMenu = () => {
    if (isMobile) {
      setDrawerVisible(!drawerVisible);
    } else {
      setCollapsed(!collapsed);
    }
  };
  const getPageTitle = () => {
    const menuItem = menuItems.find(item => item.key === location.pathname);
    return menuItem ? menuItem.label : 'Dashboard';
  };  const SideMenu = () => (
    <>      <div style={{ padding: '16px', borderBottom: '1px solid #333' }}>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center',
          alignItems: 'center'
        }}>          
          <img 
            src="/img/logo.png" 
            alt="Logo DSIACData" 
            style={{
              height: collapsed && !isMobile ? '40px' : '45px', 
              maxWidth: '100%', 
              objectFit: 'contain',
              borderRadius: '8px'
            }} 
          />
        </div>
      </div>
      
      <Menu
        mode="inline"
        selectedKeys={[location.pathname]}
        items={menuItems}
        onClick={handleMenuClick}
        style={{ 
          borderRight: 0, 
          backgroundColor: '#242424',
          color: '#fff'
        }}
        theme="dark"
      />
    </>
  );
  return (
    <Layout className="admin-layout">
      {!isMobile ? (
        <Sider 
          trigger={null} 
          collapsible 
          collapsed={collapsed} 
          width={230}
          style={{ backgroundColor: '#242424' }}
        >
          <SideMenu />
        </Sider>
      ) : (
        <Drawer
          title="Menu"
          placement="left"
          onClose={() => setDrawerVisible(false)}
          open={drawerVisible}
          bodyStyle={{ padding: 0, backgroundColor: '#242424' }}
          headerStyle={{ backgroundColor: '#242424', borderBottom: '1px solid #333' }}
          titleStyle={{ color: '#fff' }}
        >
          <SideMenu />
        </Drawer>
      )}
      
      <Layout>        <Header
          style={{
            padding: '0 16px',
            background: colorBgContainer,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottom: '1px solid #f0f0f0',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Button
              type="text"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={toggleMobileMenu}
              style={{
                fontSize: '16px',
                width: 64,
                height: 64,
              }}
            />
            
            <Title level={isMobile ? 4 : 3} style={{ margin: 0, marginLeft: '16px' }}>
              {getPageTitle()}
            </Title>
          </div>
          
          <Dropdown
            menu={{
              items: userMenuItems,
              onClick: ({ key }) => {
                if (key === 'logout') {
                  handleLogout();
                }
              }
            }}
            placement="bottomRight"
            trigger={['click']}
          >
            <Button type="text" style={{ height: '64px' }}>
              <Space>
                <Avatar size="small" icon={<UserOutlined />} />
                {!isMobile && (
                  <span style={{ color: '#333' }}>
                    {user?.username || 'Usuário'}
                  </span>
                )}
              </Space>
            </Button>
          </Dropdown>
        </Header>
        
        <Card style={{ margin: '16px', backgroundColor: '#fff', padding: '0px' }}>
          <Content className="admin-content">
            <Outlet />
          </Content>
        </Card>
      </Layout>
    </Layout>
  );
};

export default AdminLayout;
